export default __webpack_public_path__ + "static/media/P107.1.a6848315.mp3";